import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { initialValues, Schema } from './helpers';
import { useGetPostEditorBlogMutation } from '../../../../../../redux/slices/postEditorBlogSlice';
import { useParams } from 'react-router-dom';

export const FormikFunction = ({ blogPost, project, children }) => {
  const [singleContent, setSingleContent] = useState(blogPost ?? null);

  return (
    <Formik
      initialValues={singleContent ? singleContent : initialValues}
      enableReinitialize={true}
      validationSchema={Schema}
    >
      {children}
    </Formik>
  );
};
